// extracted by mini-css-extract-plugin
module.exports = {"watchHistory-page":"watchHistory_watchHistory-page__1cnhy","video-grid":"watchHistory_video-grid__3wRZP"};